import { FormField, SegmentedControl } from '@ntconsult/aluma-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/** SegmentedControl "Sim/Não" no mesmo tamanho do Input. */
export function BooleanField({
  id,
  label,
  value,
  onChange,
  disabled,
  className,
}: {
  id: string;
  label: ReactNode;
  value: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  className?: string;
}) {
  const { t } = useTranslation('common');
  const ariaLabel = typeof label === 'string' ? label : undefined;
  return (
    <FormField id={id} label={label} className={className}>
      <SegmentedControl
        value={value ? 'sim' : 'nao'}
        onValueChange={(next) => onChange(next === 'sim')}
        disabled={disabled}
        fullWidth
        aria-label={ariaLabel}
      >
        <SegmentedControl.Item value="sim">{t('yes')}</SegmentedControl.Item>
        <SegmentedControl.Item value="nao">{t('no')}</SegmentedControl.Item>
      </SegmentedControl>
    </FormField>
  );
}
